import { render, staticRenderFns } from "./ProductFieldApprovalResults.vue?vue&type=template&id=12081b94&"
import script from "./ProductFieldApprovalResults.vue?vue&type=script&lang=js&"
export * from "./ProductFieldApprovalResults.vue?vue&type=script&lang=js&"
import style0 from "./ProductFieldApprovalResults.vue?vue&type=style&index=0&id=12081b94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports